module.exports = require('./dist/feathers');



//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/@feathersjs/client/index.js
// module id = 36
// module chunks = 0